import React, {useReducer, useRef, useState} from 'react'
import PropTypes from 'prop-types';
import {makeStyles} from "@material-ui/core";
import clsx from 'clsx';
import * as Yup from "yup";
import {connect} from "react-redux";
import VS from "constants/ValidationShema";
import Form from "components/Form";
import useId from "hooks/useId";
import Typography from "@material-ui/core/Typography";
import TextInput from "components/TextInput";
import Tr from "translations/Translations";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import iconWorksReducer from "libs/iconWorksReducer";

const useStyles = makeStyles(theme => ({
    root: {
        width: '80%',
        margin: 5,
        marginLeft: '20%',
    },
    contentWrapper: {
        border: `solid 1px ${theme.palette.primary.main}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.background.paper
    },
    content: {
        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
    },
    sendDate: {
        margin: `0 ${theme.spacing(1)}px`,
        minWidth: 110
    },
    message: {
        whiteSpace: 'pre-line',
        margin: `${theme.spacing(2)}px 0`
    }
}));


function NewOpinionMessage(
    {
        groupId,
        coordinatorView,
        editable,
        message,
        opinion,
        apiPathType,
        formSubmit
    }) {

    const classes = useStyles();
    const formId = useId();
    // eslint-disable-next-line
    const [error, setError] = useState('');
    const [iconWorks, dispatchIconWorks] = useReducer(iconWorksReducer, {
        anyWorks: false,
        remove: false,
        send: false,
        save: false,
        other: false
    });
    const sendMode = useRef("");


    const onSubmit = ({contents}) => {
        const type = sendMode.current;
        dispatchIconWorks({type: type, works: true});
        PurchasingGroupStage1Service.saveOpinionMessage(groupId, apiPathType, opinion.identity, {
            identity: message.identity,
            contents: contents,
            send:  type === 'send'
        }).then(() => {
            if (opinion.identity === 0)
                PurchasingGroupStage1Service.getOpinions(groupId, apiPathType).then(() => dispatchIconWorks({type: type, works: false}))
            else
                dispatchIconWorks({type: type, works: false})
        })

    }
    const handleSubmit = (type) => {
        sendMode.current = type;
        formSubmit[formId]();
    }

    const handleDelete = () => {
        dispatchIconWorks({type: "remove", works: true});
        PurchasingGroupStage1Service.deleteOpinionMessage(groupId, apiPathType, opinion.identity, message.identity).catch(() => dispatchIconWorks({type: "remove", works: false}))
    }

    const getButtons = () => {
        const buttons = [];
        if (opinion.identity > 0)
            buttons.push(createButton(Tr('delete'), handleDelete, 'outlined', !editable || iconWorks.anyWorks, undefined, iconWorks.remove ));
        buttons.push(createButton(Tr('save'), () => handleSubmit('save'), 'outlined', !editable || iconWorks.anyWorks, undefined, iconWorks.save ));
        buttons.push(createButton(Tr('send'), () => handleSubmit('send'), undefined, !editable || iconWorks.anyWorks, undefined, iconWorks.send ));
        return buttons;
    }
    return (
        <div className={clsx(classes.root)}>

            <div className={clsx(classes.contentWrapper)}>
                <div className={classes.content}>
                    <Form
                        initialValues={{
                            contents: message.contents
                        }}
                        initialTouched={{
                            contents: true
                        }}
                        onSubmit={onSubmit}
                        validationSchema={Yup.object().shape({
                            contents: VS.string(),
                        })}
                        id={formId}
                    >
                        {(formikProps) => (<>
                                {error && <Typography color='error'>{error}</Typography>}


                                <TextInput
                                    id='contents'
                                    formikProps={formikProps}
                                    label={Tr('contents')}
                                    disabled={iconWorks.anyWorks}
                                    multiline
                                    required
                                />
                                <MultiButton className={classes.buttons} buttons={getButtons()}/>
                            </>


                        )}
                    </Form>
                </div>
            </div>

        </div>
    )
}

NewOpinionMessage.propTypes = {
    classes: PropTypes.any,
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(NewOpinionMessage);